









































































import { ParamServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
import { columns } from "./components/column";
import Add from "./components/create.vue";
const service = new ParamServiceProxy();
const options = {
  listApi: service.list.bind(service),
  deleteApi: service.remove.bind(service),
};

export default {
  components: { Add },
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title),
        };
      }); // 表单配置
    },
    rowSelection() {
      const { selectedRowKeys }: any = this;
      return {
        selectedRowKeys,
        onChange: (selectedRowKeys: any) => {
          this.selectedRowKeys = selectedRowKeys;
        },
      };
    },
  },
  data() {
    return {
      dialog: false,
      ...options,
      dataSource: [], // 列表数据
      totalContent: 0, // 总数
      query: {
        size: 30,
        current: 1,
      },
      form: {
        paramName: "", // 参数名称
        paramKey: "", // 参数键名
        paramValue: "", //参数键名
        disabled: false, // 查看/编辑
      },
      selectedRowKeys: [],
      Rowkey: "", // 所选表单行
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleCreate() {
      this.dialog = true;
      this.form = {
        paramName: "",
        paramKey: "",
        paramValue: "",
        disabled: false,
      };
    },
    handleSearch() {
      this.query.current = 1;
      this.getList();
    },
    handleDelete() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      let that = this;
      let ids = "";
      if (this.selectedRowKeys.length) {
        ids = this.selectedRowKeys.join(",");
      } else {
        ids = this.selectedRowKeys[0];
      }
      this.$confirm({
        content: "是否确定删除",
        onOk() {
          that.deleteApi(ids).then((res) => {
            that.selectedRowKeys = [];
            that.$message.success(that.$t("delete_success"));
            that.getList();
          });
        },
      });
    },
    handleUpdate() {
      this.dialog = false;
      this.getList();
    },
    handleEdit(data) {
      let item = Object.assign({}, data);
      this.form = item;
      item.disabled = false;
      this.dialog = true;
    },
    handleRead(data) {
      let item = Object.assign({}, data);
      this.form = item;
      item.disabled = true;
      this.dialog = true;
    },
    async getList() {
      const res = await this.listApi(
        this.query.current,
        this.query.paramKey,
        this.query.paramName,
        "",
        this.query.size
      );
      const { data } = res;
      if (data.records.length) {
        this.dataSource = data.records;
        this.totalContent = data.total;
      }else{
        this.dataSource = [];
        this.totalContent = 0;
      }
    },
    pageIndexchange(current: any) {
      this.query.current = current;
      this.getList();
    },
    totalFanyi(number: any) {
      const total = this.$t("Total…items");
      return total.replace("{0}", number);
    },
  },
};
